import { Component, OnInit, Inject, LOCALE_ID } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgForm, FormControl } from "@angular/forms";
import { ReportService } from "../services/report.service";
import { QuoteService } from "../../quote/services/quote.service";
import { MonthType } from "../../shared/models/month.type.interface";
import { User } from "../../shared/models/user.interface";
import { LeadSourceType } from "../../shared/models/lead.source.type.interface";
import { LeadSource, LeadSourceResult } from "../models/lead.source.interface";
import { FileService } from "../../shared/services/file.service";
import { AbstractReportComponent } from "../abstract.report.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { RolePermission } from "../../shared/models/role.permission.enum";

export interface LeadSourceParameterData {
  leadSource: LeadSource;
  validation: string;
  showMargins: boolean;

  salespersons: User[];
  leadSourceTypes: LeadSourceType[];
  years: number[];
  months: MonthType[];
}

@Component({
  selector: 'app-lead-source',
  templateUrl: './lead.source.component.html',
  styleUrls: ['./lead.source.component.scss']
})
export class LeadSourceComponent extends AbstractReportComponent implements OnInit {

  report: LeadSourceResult = null;
  parameters: LeadSource = {
    salespersonId: null,
    grossMargin: true,
    leadSourceTypes: new Array(),
    year: (new Date()).getFullYear(),
    startMonth: 0,
    endMonth: 11
  } as LeadSource;

  salesperson: User;
  selectedLeadSources: string;
  showMargins: boolean = false;

  salespersons: User[];
  leadSourceTypes: LeadSourceType[];

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private quoteService: QuoteService, private reportService: ReportService, private fileService: FileService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.showMargins = QuoteService.hasPermission(RolePermission.ViewEditMargins);
    this.parameters.showMargins = this.showMargins;

    this.quoteService.getSalespersons()
      .subscribe({
        next: (data) => {
          this.salespersons = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.quoteService.getLeadSourceTypes()
      .subscribe({
        next: (data) => {
          this.leadSourceTypes = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.setupDates();
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.parameters.showMargins = this.showMargins;
        this.isRequesting = true;
        this.reportService.getLeadSourceExport(this.parameters, formatData.format, formatData.locale)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'LeadSource' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
    });

  }

  showParameters() {
    if (this.salespersons == null ||
      this.leadSourceTypes == null) return;

    const dialogRef = this.dialog.open(LeadSourceParameterDialog, {
      width: '550px',
      data: {
        leadSource: (<any>Object).assign({}, this.parameters),
        salespersons: this.salespersons,
        leadSourceTypes: this.leadSourceTypes,
        years: this.years,
        months: this.months
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.leadSource as LeadSource;
        this.reportService.setupParameters(this.parameters);

        this.salesperson = this.salespersons.find(s => s.id == this.parameters.salespersonId);
        this.selectedLeadSources = '';
        let strDelim = '';
        for (let type_ID of this.parameters.leadSourceTypes) {
          let leadSourceType = this.leadSourceTypes.find(l => l.leadSourceType_ID == type_ID);
          this.selectedLeadSources += strDelim + leadSourceType.leadSourceType_Desc;
          strDelim = ', ';
        };

        this.reportService.getLeadSourceReport(result.leadSource)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'lead.source.parameter.dialog',
  templateUrl: 'lead.source.parameter.dialog.html',
})
export class LeadSourceParameterDialog {

  constructor(
    public dialogRef: MatDialogRef<LeadSourceParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: LeadSourceParameterData) { }

  runReport(form: NgForm): void {
    if (this.data.leadSource.leadSourceTypes.length == 0) {
      form.controls['validation'].setErrors({ 'incorrect': true });
      return;
    }

    form.controls['validation'].setErrors(null);

    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
